export default class GpecSyntheseRealiseDto {
  id;
  marche;
  trimestre;
  trimestrePrecedent;
  postes = [];
  commentaire;
  statut;
  jourSoumissionPassed;
  user;
}
